import { useState } from "react";
import { Link } from "react-router-dom";
import { format, parse } from "date-fns";
import { useApi } from "@/lib/api";
import { Page, Spinner, Empty, UserAvatar } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MEDAL = ["bg-[#FF5C00] text-white", "bg-stone-900 text-white", "bg-stone-300 text-stone-900"];
const monthLabel = (m) => { try { return format(parse(m, "yyyy-MM", new Date()), "MMMM yyyy"); } catch { return m; } };

const Category = ({ k, cat }) => (
  <div data-testid={`leaderboard-cat-${k}`} className="rise rounded-3xl bg-white border border-stone-200 p-6">
    <h3 className="font-display text-xl font-bold">{cat.title}</h3>
    {cat.rows.length === 0 ? <p className="text-sm text-stone-500 mt-3">No entries yet.</p> : (
      <ol className="mt-4 space-y-2">
        {cat.rows.map((r, i) => (
          <li key={r.user.id}>
            <Link to={`/creators/${r.user.id}`} data-testid={`leaderboard-${k}-row-${i}`} className="flex items-center gap-3 p-2 rounded-2xl hover:bg-stone-100 transition-colors">
              <span className={`h-8 w-8 rounded-full grid place-items-center font-mono text-xs font-bold ${MEDAL[i] || "bg-stone-100 text-stone-500"}`}>{i + 1}</span>
              <UserAvatar user={r.user} className="h-9 w-9" />
              <span className="flex-1 min-w-0 truncate font-medium">{r.user.name}</span>
              <span className="font-display text-2xl font-black">{r.count}</span>
            </Link>
          </li>
        ))}
      </ol>
    )}
  </div>
);

export default function Leaderboard() {
  const { data: months } = useApi("/leaderboard/months");
  const [month, setMonth] = useState("");
  const { data, isLoading } = useApi(`/leaderboard${month ? `?month=${month}` : ""}`);
  const current = month || data?.month || "";
  return (
    <Page>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500">Monthly</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Leaderboard</h1>
        </div>
        {months?.months?.length > 0 && (
          <Select value={current} onValueChange={setMonth}>
            <SelectTrigger data-testid="leaderboard-month-select" className="w-52 h-11 rounded-full bg-white"><SelectValue placeholder="Month" /></SelectTrigger>
            <SelectContent>{months.months.map((m) => <SelectItem key={m} value={m} data-testid={`leaderboard-month-${m}`}>{monthLabel(m)}</SelectItem>)}</SelectContent>
          </Select>
        )}
      </div>
      <div className="mt-10">
        {isLoading ? <Spinner /> : !data?.categories ? <Empty title="No leaderboard yet" /> : (
          <div className="grid md:grid-cols-2 gap-6">{Object.entries(data.categories).map(([k, cat]) => <Category key={k} k={k} cat={cat} />)}</div>
        )}
      </div>
    </Page>
  );
}
